import { render, staticRenderFns } from "./inStorageModal.vue?vue&type=template&id=72a7ceb0&scoped=true&"
import script from "./inStorageModal.vue?vue&type=script&lang=js&"
export * from "./inStorageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7ceb0",
  null
  
)

export default component.exports